import { render, staticRenderFns } from "./SuperProjectNavbar.vue?vue&type=template&id=047d8608&"
import script from "./SuperProjectNavbar.vue?vue&type=script&lang=js&"
export * from "./SuperProjectNavbar.vue?vue&type=script&lang=js&"
import style0 from "./SuperProjectNavbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports